import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  data() {
    return {
      datacollection: {
        labels: ['Real Estate', 'Retirement', 'Cash', 'Public Securities', 'Private Securities'],
        datasets: [
          {
            backgroundColor: [
              'rgba(51, 153, 255, 0.95)',
              'rgba(51, 153, 255, 0.70)',
              'rgba(51, 153, 255, 0.40)',
              'rgba(51, 153, 255, 0.20)',
              'rgba(51, 153, 255, 0.05)',
            ],
            data: [60, 20, 14, 4, 2],
          },
        ],
      },
    };
  },
  mounted() {
    const vm = this;
    vm.renderChart(vm.datacollection, {
      responsive: true,
      maintainAspectRatio: false,
      cutoutPercentage: 0,
      tooltips: {
        callbacks: {
          title: (tooltipItems, metadata) => {
            const something = metadata.labels[tooltipItems[0].index];
            return `${something}`;
          },
          label: (tooltipItem, metadata) => {
            const data = metadata.datasets[0].data[tooltipItem.index];
            return ` ${data}%`;
          },
        },
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/charts/PortfolioDist.js